import React from "react";
import "./CompanyOverview.css"; // You can reuse your existing CSS
import { Helmet } from "react-helmet-async";
const PrivacyPolicy = () => {
    return (
        <div className="company-wrapper">
            <Helmet>
  <title>Privacy Policy | APTech Solution</title>
  <meta 
    name="description" 
    content="Read APTech Solution’s privacy policy to understand how we protect your data, ensure confidentiality, and handle user information responsibly." 
  />
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Privacy Policy",
        "url": "https://aptechsolution.com/privacy-policy",
        "description": "APTech Solution’s privacy policy regarding data protection and confidentiality."
      }
    `}
  </script>
</Helmet>


            <div className="company-card">
                <h1 className="main-heading">🔒 Privacy Policy for A.P Tech Solution</h1>
                <p>
                    At A.P Tech Solution, accessible from{' '}
                    <a href="https://www.aptechsolution.com" target="_blank" rel="noopener noreferrer">
                        https://www.aptechsolution.com
                    </a>, the privacy of our visitors and clients is one of our highest priorities. This Privacy Policy outlines the types of information collected and recorded by A.P Tech Solution and how we use it.
                </p>
                <p>
                    If you have any questions or need further details about our Privacy Policy, please contact us at{' '}
                    <a href="mailto:info@aptechsolution.com">info@aptechsolution.com</a>.
                </p>

                <h2>Consent</h2>
                <p>
                    By using our website, you consent to our Privacy Policy and agree to its terms.
                </p>

                <h2>Information We Collect</h2>
                <p>
                    The personal information we collect and why we ask for it will always be explained at the point of collection.
                </p>
                <p>
                    If you contact us directly, we may collect your name, email address, phone number, company name, and any other information you voluntarily share.
                </p>
                <p>
                    When you fill out forms on our website (such as contact or inquiry forms), we may collect your name, company name, address, email address, phone number, and other details to process your request.
                </p>

                <h2>How We Use Your Information</h2>
                <ul>
                    <li>To operate and maintain our website and services</li>
                    <li>To improve, personalize, and expand our services</li>
                    <li>To analyze how users interact with our website</li>
                    <li>To communicate with you about inquiries, support, or services</li>
                    <li>To send updates and marketing (with your consent)</li>
                    <li>To detect and prevent fraudulent activities</li>
                </ul>

                <h2>Log Files</h2>
                <p>
                    A.P Tech Solution follows standard procedures for using log files. These files log visitors when they access websites. This data includes:
                </p>
                <ul>
                    <li>IP Address</li>
                    <li>Browser Type and Version</li>
                    <li>Internet Service Provider (ISP)</li>
                    <li>Date and Time of Visit</li>
                    <li>Referring / Exit Pages</li>
                    <li>Number of Clicks</li>
                </ul>
                <p>
                    This information is not personally identifiable and is used for site analytics and administration.
                </p>

                <h2>Cookies and Web Beacons</h2>
                <p>
                    Like most websites, A.P Tech Solution uses cookies to enhance user experience, store preferences, and analyze website traffic.
                </p>

                <h2>Third-Party Privacy Policies</h2>
                <p>
                    This Privacy Policy does not apply to other websites or services linked from our site. We advise you to consult the privacy policies of those third-party services for detailed information.
                </p>
                <p>
                    You can manage cookies through your browser settings. Visit your browser’s help section for detailed steps.
                </p>

                <h2>Data Protection Rights (GDPR & CCPA)</h2>
                <p>
                    Depending on your jurisdiction, you may have the right to:
                </p>
                <ul>
                    <li>Access the personal data we hold about you</li>
                    <li>Correct inaccurate data</li>
                    <li>Request deletion of your data</li>
                    <li>Restrict or object to how we process your data</li>
                    <li>Request data portability</li>
                    <li>Withdraw consent at any time</li>
                </ul>
                <p>
                    To exercise any of these rights, please email us at{' '}
                    <a href="mailto:info@aptechsolution.com">info@aptechsolution.com</a>. We respond within 30 days.
                </p>

                <h2>Children’s Privacy</h2>
                <p>
                    A.P Tech Solution does not knowingly collect any information from children under 13. If you believe a child has provided us with their data, please contact us and we will promptly delete it.
                </p>

                <h2>Changes to This Privacy Policy</h2>
                <p>
                    We may update this Privacy Policy periodically. Updates will be posted on this page with a revised “Last Modified” date.
                </p>
                <p><strong>Last Modified:</strong> 19 July 2025</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
